import React from "react";
import "./Print_Media_Why_Choose_Us.css";
import Print_Media_Why_Choose_Us_list_card from "../../../Common_Component/Print_Media_Why_Choose_Us_list_card/Print_Media_Why_Choose_Us_list_card";

function Print_Media_Why_Choose_Us(props) {
  return (
    <>
      <section className="Print_Media_Why_Choose_Us">
        <div className="container">
          <div className="row  justify-content-center">
            <div className="col-xl-8 col-md-7 p-0 order-md-1 order-2">
              <div className="main_content_holder">
                <div className="heading_holder">
                  <h3>
                    Why <br /> Choose Us?
                  </h3>
                </div>

                <div className="content_holder">



                  {props?.why_choose_data?.length > 0 && props?.why_choose_data?.map((item) => {
                    return (
                      <div className="Print_Media_Why_Choose_Us_list">
                        <Print_Media_Why_Choose_Us_list_card title={item?.title} imgSrc={item?.imgSrc} subtext={item?.subtext} />
                      </div>
                    )
                  })}


                </div>
              </div>
            </div>

            <div className="col-xl-4 col-md-5 col-sm-5 col-6 p-0 order-md-2 order-1">
              <div className="main_img_holder">
                <img
                  className="Print_Media_img"
                  src={props?.rightImg
                  }
                  alt="Print_Media_img"
                />
                <div className="overlay_holder"></div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}

export default Print_Media_Why_Choose_Us;
